import { components } from '@/types/api';
import PlusSquare from '@/assets/icons/plus_square.svg?react';
import JarEmpty from '@/assets/icons/jar_empty.svg?react';
import useOpenApiClient from '@/hooks/useOpenApiClient';
import { useQuery } from '@tanstack/react-query';
import { format, isSameWeek } from 'date-fns';
import { LoyalityRulesModal } from './LoyalityRulesModal';
import { LoyaltyActions } from '@/lib/constants';
export function LoyalityProgramActivites({
  account,
}: {
  account: components['schemas']['AccountDetailsOutput'];
}) {
  const { apiFetch } = useOpenApiClient();
  const accountActivitiesQuery = useQuery({
    queryKey: ['v1', 'accounts', account?.id, 'activities'],
    queryFn: () =>
      apiFetch.GET('/accounts/{account_id}/activities', {
        params: {
          path: { account_id: account?.id },
        },
      }),
    enabled: Boolean(account?.id),
    select: (data) => data.data?.data,
  });
  return (
    <>
      <div className="text-foreground relative flex items-center justify-between rounded-[10px] bg-white p-4 text-xl leading-normal font-bold">
        <span>
          You have earned
          <br />
          <span className="text-primary">{account.balance} points</span>
        </span>
        <JarEmpty className="mr-5" />
        <LoyalityRulesModal account={account} />
      </div>
      <h3 className="text-foreground px-5 pt-5 pb-4 text-base leading-normal font-bold">
        Recent activities
      </h3>
      <div className="scrollbar-hide no-scrollbar flex flex-col gap-1 overflow-y-auto rounded-[10px] bg-white p-3">
        {accountActivitiesQuery.data?.map((activity) => (
          <div
            className="flex flex-row items-center gap-4 border-b border-b-gray-200 py-1.5"
            key={activity.id}
          >
            <PlusSquare />
            <div className="flex flex-col">
              <span className="text-base">
                <strong>{activity.amount} pts </strong>
                {activity.points_description}
              </span>
              <span className="text-xs opacity-70">
                {formatDateToDayIfThisWeek(activity.transaction_date)} |
                {LoyaltyActions[activity.description as keyof typeof LoyaltyActions]}
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

function formatDateToDayIfThisWeek(date: string) {
  const today = new Date();
  const transactionDate = new Date(date);
  if (isSameWeek(transactionDate, today)) {
    return format(transactionDate, 'EEEE');
  }
  return format(transactionDate, 'MM/dd/yyyy');
}
